import React, { Component } from 'react'
import { Button, Form, Row } from 'react-bootstrap';
import moment from 'moment';
import LoaderBox from '../../../shared/loaders/loader.box';
import { apiRequest } from "../../../../functions/api";
import { pushNotification } from "../../../../functions/notifications";

const COLUMNS = [
    { key: 'id', label: 'Identifiant' },
    { key: 'familyName', label: 'Nom' },
    { key: 'givenName', label: 'Prénom' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Téléphone' },
    { key: 'object', label: 'Objet' },
    { key: 'message', label: 'Message' },
    { key: 'tags', label: 'Tags' },
    { key: 'createdAt', label: 'Date de réception' }
];

class MessagesExport extends Component {
    constructor(props) {
        super(props);

        this.onColumnChange = this.onColumnChange.bind(this);
        this.onTagChange = this.onTagChange.bind(this);
        this.onExportModeChange = this.onExportModeChange.bind(this);
        this.onFromDateChange = this.onFromDateChange.bind(this);
        this.onExport = this.onExport.bind(this);

        this.state = {
            loading: false,
            loadingMess: "",

            availableTags: [],
            selectedTags: {},
            selectedColumns: COLUMNS.reduce((acc, column) => ({ ...acc, [column.key]: !['tags', 'message'].includes(column.key) }), {}),
            exportMode: "all",
            fromDate: "",
            errors: {}
        };
    }

    componentDidMount() {
        this.getMetadata();
    }

    getMetadata() {
        apiRequest({
            url: '/www.forms.extract.metadata/get'
        }).then((res) => {
            if (res && res.data.http_code === 200 && res.data.data && res.data.data.metadata) {
                this.setState({ availableTags: res.data.data.metadata.tags });
            } else {
                pushNotification({
                    type: "error",
                    title: "Erreur du serveur",
                    content: <p>Impossible de récupérer la liste des tags disponibles.</p>,
                    icon: "mdi mdi-close"
                });
            }
        });
    }

    onColumnChange(key) {
        return (e) => {
            this.setState({
                selectedColumns: { ...this.state.selectedColumns, [key]: e.target.checked }
            });
        };
    }

    onTagChange(tag) {
        return (e) => {
            this.setState({
                selectedTags: { ...this.state.selectedTags, [tag]: e.target.checked }
            });
        };
    }

    onExportModeChange(mode) {
        return () => {
            this.setState({ exportMode: mode });
        };
    }

    onFromDateChange(e) {
        this.setState({ fromDate: e.target.value });
    }

    validate(tags) {
        const errors = {};

        if (tags.length === 0) {
            errors.tags = "Sélectionnez au moins un tag";
        }

        if (this.state.exportMode === "fromDate") {
            if (!this.state.fromDate) {
                errors.fromDate = "La date est obligatoire";
            } else if (this.state.fromDate > moment().format('YYYY-MM-DD')) {
                errors.fromDate = "La date doit être antérieure ou égale à aujourd'hui";
            }
        }

        return errors;
    }

    onExport(e) {
        e.preventDefault();
        if (this.state.loading) return;

        const columns = COLUMNS.map((c) => c.key).filter((key) => this.state.selectedColumns[key]);
        const tags = Object.keys(this.state.selectedTags).filter((tag) => this.state.selectedTags[tag]);

        const errors = this.validate(tags);
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        this.setState({ errors: {} });

        const data = { columns };
        if (tags.length > 0) data.tags = tags;
        if (this.state.exportMode === "fromDate" && this.state.fromDate) data.fromDate = this.state.fromDate;

        this.setState({ loading: true, loadingMess: "Export en cours" });

        apiRequest({
            url: '/www.forms.extract/post',
            data,
            config: { responseType: 'blob' }
        }).then((res) => {
            this.setState({ loading: false });

            if (!res) {
                pushNotification({
                    type: "error",
                    title: "Erreur du serveur",
                    content: <p>Une erreur inconnue est survenue. Veuillez réessayer.</p>,
                    icon: "mdi mdi-close"
                });
                return;
            }

            const contentType = res.headers['content-type'] || "";
            if (contentType.includes('application/json')) {
                res.data.text().then((text) => {
                    let body = {};
                    try {
                        body = JSON.parse(text);
                    } catch (err) {
                        // ignore, handled by fallback below
                    }
                    pushNotification({
                        type: "error",
                        title: "Export impossible",
                        content: <p>{body.status_code ? `Erreur : ${body.status_code}` : "Une erreur est survenue lors de l'export."}</p>,
                        icon: "mdi mdi-close"
                    });
                });
                return;
            }

            const disposition = res.headers['content-disposition'] || "";
            const match = disposition.match(/filename="?([^"]+)"?/);
            const filename = match ? match[1] : `messages-contact-${moment().format('YYYY-MM-DD')}.csv`;

            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
    }

    render() {
        return (
            <div className="row">
                <div className="col grid-margin stretch-card">
                    <div className="card">
                        <LoaderBox show={this.state.loading} mess={this.state.loadingMess} className="card" inline>
                            <div className="card-body">
                                <h4 className="card-title">Exporter les messages de contact</h4>
                                <Form className="col-12" onSubmit={this.onExport}>
                                    <Row className="mb-3">
                                        <Form.Group className="form-group full w-100">
                                            <Form.Label column className="p-0">Période</Form.Label>
                                            <div className="flex row m-0">
                                                <div className="form-check m-0 mr-4">
                                                    <label className="form-check-label text-muted">
                                                        <input
                                                            name="exportMode"
                                                            type="radio"
                                                            className="form-check-input"
                                                            checked={this.state.exportMode === "all"}
                                                            onChange={this.onExportModeChange("all")}
                                                        />
                                                        <i className="input-helper" />
                                                        Tous les messages
                                                    </label>
                                                </div>
                                                <div className="form-check m-0">
                                                    <label className="form-check-label text-muted">
                                                        <input
                                                            name="exportMode"
                                                            type="radio"
                                                            className="form-check-input"
                                                            checked={this.state.exportMode === "fromDate"}
                                                            onChange={this.onExportModeChange("fromDate")}
                                                        />
                                                        <i className="input-helper" />
                                                        Depuis une date
                                                    </label>
                                                </div>
                                            </div>
                                            {this.state.exportMode === "fromDate" &&
                                                <Form.Control
                                                    type="date"
                                                    name="fromDate"
                                                    className="mt-2 w-auto"
                                                    max={moment().format('YYYY-MM-DD')}
                                                    value={this.state.fromDate}
                                                    onChange={this.onFromDateChange}
                                                />
                                            }
                                            {this.state.errors.fromDate &&
                                                <Form.Control.Feedback type="invalid">{this.state.errors.fromDate}</Form.Control.Feedback>
                                            }
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group className="form-group full w-100">
                                            <Form.Label column className="p-0">Tags</Form.Label>
                                            <div className="flex row m-0">
                                                {this.state.availableTags.length === 0 ?
                                                    <span className="text-muted">Aucun tag disponible</span> :
                                                    this.state.availableTags.map((tag) => (
                                                        <div className="form-check m-0 mr-4" key={tag}>
                                                            <label className="form-check-label text-muted">
                                                                <input
                                                                    name="tags"
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={!!this.state.selectedTags[tag]}
                                                                    onChange={this.onTagChange(tag)}
                                                                />
                                                                <i className="input-helper" />
                                                                {tag}
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {this.state.errors.tags &&
                                                <Form.Control.Feedback type="invalid">{this.state.errors.tags}</Form.Control.Feedback>
                                            }
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Form.Group className="form-group">
                                            <Form.Label column className="p-0">Colonnes à exporter</Form.Label>
                                            <div className="flex row m-0">
                                                {COLUMNS.map((column) => (
                                                    <div className="form-check my-1 col-3" key={column.key}>
                                                        <label className="form-check-label text-muted">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={!!this.state.selectedColumns[column.key]}
                                                                onChange={this.onColumnChange(column.key)}
                                                            />
                                                            <i className="input-helper" />
                                                            {column.label}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </Form.Group>
                                    </Row>
                                    <div className="btn-container-inline-right mb-0">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            disabled={this.state.loading}
                                        >
                                            <i className="mdi mdi-download" />Exporter en CSV
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </LoaderBox>
                    </div>
                </div>
            </div>
        );
    }
}

export default MessagesExport;
